import { useMemo } from "react";
import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { createIdMap } from "@tellescope/utils";
import { useTranslation } from "react-i18next";
import { BadgeListCell } from "./BadgeListCell";

export interface JourneysFieldCellProps {
  journeys: Record<string, string>;
}

export const JourneysFieldCell = ({ journeys }: JourneysFieldCellProps) => {
  const { t } = useTranslation("contacts");

  const journeyIds = useMemo(() => Object.keys(journeys), [journeys]);

  const journeysQuery = useTellescopeQuery({
    model: "journeys",
    method: "getByIds",
    request: { ids: journeyIds },
    enabled: journeyIds.length > 0,
    crossQueryCacheSharing: true,
    select: (data) => createIdMap(data.matches),
  });

  const items = useMemo(
    () =>
      Object.entries(journeys).map(([journeyId, state]) => {
        const title = journeysQuery.data?.[journeyId]?.title ?? t("Unknown journey");
        return {
          key: journeyId,
          label: state ? `${title}: ${state}` : title,
        };
      }),
    [journeys, journeysQuery.data, t]
  );

  return <BadgeListCell items={items} emptyLabel={t("No journeys")} />;
};
